const doc = [({"da":({"models":({"school_class_check_in_event":({"habit_change":"Vaneændring", "unicorn_effect":"Unicorn effekt"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;